export class HttpNotFoundException extends Error {
  status: number;

  code: string;

  constructor(message: string) {
    super(message);
    this.name = 'HttpNotFoundException';
    this.status = 404;
    this.code = 'NOT_FOUND';
  }
}
